import type { VideoCategory } from "@/types/video";

export const videoCategories: VideoCategory[] = [
  {
    slug: "short-video",
    name: "短视频",
    description: "精选搞笑、生活与美食短视频，每天上新，随时随地发现有趣瞬间。",
    subCategories: ["搞笑", "生活", "美食"],
    cover:
      "https://readdy.ai/api/search-image?query=Cheerful%20young%20creator%20holding%20a%20smartphone%20recording%20a%20fun%20short%20video%20in%20a%20bright%20modern%20apartment%20warm%20natural%20light%20clean%20minimal%20background%20vivid%20color%20grading%20high%20detail&width=640&height=420&seq=cat-short-video&orientation=landscape",
  },
  {
    slug: "net-movie",
    name: "网络电影",
    description: "动作、喜剧与科幻网络电影抢先看，高清画质，精彩剧情一站直达。",
    subCategories: ["动作", "喜剧", "科幻"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20production%20scene%20with%20a%20director%20chair%20and%20camera%20in%20a%20dark%20studio%20dramatic%20warm%20lighting%20moody%20atmosphere%20clean%20minimal%20background%20high%20detail%20editorial%20quality&width=640&height=420&seq=cat-net-movie&orientation=landscape",
  },
  {
    slug: "variety",
    name: "娱乐综艺",
    description: "真人秀、音乐与访谈综艺合集，明星同台，欢乐治愈不停歇。",
    subCategories: ["真人秀", "音乐", "访谈"],
    cover:
      "https://readdy.ai/api/search-image?query=Stage%20with%20colorful%20warm%20spotlights%20and%20microphone%20for%20a%20live%20entertainment%20show%20energetic%20atmosphere%20clean%20minimal%20background%20vivid%20warm%20color%20grading%20high%20detail%20editorial%20quality&width=640&height=420&seq=cat-variety&orientation=landscape",
  },
];